<template>
  <nav class="navbar navbar-dark bg-primary">
    <div class="container-fluid">
      <a href="/admin/" class="navbar-brand">簽呈系統</a>
    </div>
  </nav>
  <div class="container">
    <router-view />
  </div>
</template>

<style>
body {
  font-family: Arial, sans-serif;
  background-color: #f8f9fa;
  height: 100vh;
  align-content: center;
  justify-content: center;
  text-align: center;
}
#app {
  padding-bottom: 10px; /* 預留底部空間 */
}
.container {
  width: 80%;
  max-width: 550px;
  min-height: 180px;
  align-content: center;
  justify-content: center;
  background-color: #ffffff;
  padding: 20px;
  margin: 100px auto 60px auto; /* 新增這行 */
  border: 1px solid #dee2e6;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.navbar {
  width: 100vw;
  top: 0;
  position: fixed;
  font-weight: 700;
  padding: 0;
}
@media screen and (max-width: 900px) {
  .container {
    min-width: 235px;
    margin: 60px auto 20px auto; /* 上、右、下、左間距 */
  }
}
</style>
